import { PartialId } from '@attain-apps/string-builder'

import * as core from '../../../../../../../../core'
import * as organization from '../../organization'

export const RESOURCE = {
  payload: {
    description: 'A sub-unit or branch of a non-profit Institution',
    dimension: organization.RESOURCE.payload,
    level: 0,
    name: 'Affiliate',
    partialId: PartialId.Standard.create('affiliate'),
  },
  type: core.quiver.Resource.Type.DmsEntity,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.DmsEntity>

export const MODEL_ID = core.dms.models.Entity.Id.from({
  context: core.dms.models.Entity.Id.Context.from(RESOURCE.payload.dimension),
  partialId: RESOURCE.payload.partialId,
})
